module.exports = __webpack_public_path__ + "static/Alaska2Sm-9db2763daaab15a4212693a07020cebc.jpg";